import React from 'react';
export function Newsletter() {
  return <section className="bg-eofa-black py-20 md:py-32 border-t border-eofa-dark" data-id="element-110">
      <div className="container mx-auto px-6" data-id="element-111">
        <div className="max-w-[600px] mx-auto text-center" data-id="element-112">
          <span className="text-eofa-yellow tracking-[0.2em] text-[13px] uppercase font-bold mb-4 block" data-id="element-113">
            STAY IN THE LOOP
          </span>
          <h2 className="text-eofa-white font-heading font-black text-[26px] md:text-[36px] leading-[1.1] tracking-tighter mb-4" data-id="element-114">
            Get new episodes in your inbox.
          </h2>
          <p className="text-eofa-body text-base mb-10" data-id="element-115">
            Drop your email and we'll send the new episode every week. Plus the
            occasional behind the scenes.
          </p>

          <form className="flex flex-col md:flex-row gap-4 md:gap-0 mb-4" data-id="element-116">
            <input type="email" placeholder="Enter your email" className="flex-1 bg-[#222] text-eofa-white placeholder:text-eofa-white/50 border-none rounded-md md:rounded-r-none md:rounded-l-md px-6 min-h-[48px] focus:ring-2 focus:ring-eofa-yellow outline-none" required data-id="element-117" />
            <button type="submit" className="bg-eofa-yellow text-eofa-black font-bold rounded-md md:rounded-l-none md:rounded-r-md px-8 min-h-[48px] hover:bg-yellow-400 transition-colors" data-id="element-118">
              Subscribe
            </button>
          </form>

          <div className="flex items-start gap-3 text-left" data-id="element-119">
            <input type="checkbox" id="consent" className="mt-1 w-4 h-4 rounded border-gray-300 text-eofa-yellow focus:ring-eofa-yellow bg-[#222]" required data-id="element-120" />
            <label htmlFor="consent" className="text-eofa-body text-[13px] leading-tight" data-id="element-121">
              I'd like to receive emails about new episodes and updates from
              LetLois.
            </label>
          </div>
        </div>
      </div>
    </section>;
}